import { useEffect, useState } from 'react';

// Same boundary as antd's md breakpoint; matchMedia gives the right value on the first render
export const MOBILE_QUERY = '(max-width: 767.98px)';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(media.matches);
    media.addEventListener('change', onChange);
    onChange();
    return () => media.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};
